export default "__VITE_ASSET__236379c1__"